import { render } from "./Visited.vue?vue&type=template&id=2534d36f&scoped=true"
import script from "./Visited.vue?vue&type=script&lang=js"
export * from "./Visited.vue?vue&type=script&lang=js"

import "./Visited.vue?vue&type=style&index=0&id=2534d36f&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2534d36f"]])

export default __exports__